import { NaniumObject, Type } from 'nanium/objects';

export class StudyProgram extends NaniumObject<StudyProgram> {
	@Type(String) id?: string;
	@Type(String) semester: string;									// summer semester: 1, winter semester: 2 = '20252'
	@Type(String) programCode: string;							// antr.stg = 'BD6'   --- Advanced Manufacturing
	@Type(String) degree: string;										// antr.abschl = '88'   --- Master
	@Type(String) degreeForm: string; 							// antr.stufrm = '7'   --- konsekutiver Master
	@Type(String) typeRegardingSubject: string;   	// antr.kzfa = 'H'   --- Hauptfach
	@Type(String) typeRegardingTime: string;				// antr.stutyp = 'V'   --- Vollzeit
	@Type(String) typeRegardingLocation: string			// antr.stuart = 'P'   --- Präsenzstudium
	@Type(String) specialization?: string 					// antr.vert = null   --- Vertiefung
	@Type(String) location?: string;  							// antr.stort = null   --- Studienort

	@Type(String) name: string;
	@Type(String) degreeName: string;
	@Type(String) degreeNameLong: string;

	// add Zulassungsvorraussetzungen

	isMasterDegree(): boolean {
		return this.degree === '88';
	};
}
